export type DeviceTechProps = {
  wifiSsid: string | null,
  localIp: string | null,
  model: string | null,
  manufacturer: string | null,
  appVersion: string | null,
};

export type PosProps = {
  status: PosStatuses,
  statusCode: number,
  physicalCash: number,
  testCash: number,
  cardCash: number,
  posType: string,
};

export enum PosStatuses {
  UNDEFINED = 3,
  ERROR = 0,
  SUCCESS = 1,
  WARNING = 2
}

export enum PosErrorStatusCodes {
  NO_PAPER = 0,
  PROGRAMMING_MODE_IS_NOT_ENABLED = 5
}

export const POS_TEXT_ERROR_CODES = [
  'UNSTABLE_CONNECTION',
  'CASHBOX_EMPTY_REPLY',
  'CASHBOX_BUSY',
  'CASHBOX_TIMEOUT'
];
